module.exports = __webpack_public_path__ + "img/copertina-libro3.6c65afdf.jpg";